import React from 'react';

const LegendRow = ({ color, label }) => (
    <div className="flex items-start gap-2.5">
        <span
            aria-hidden="true"
            className="mt-[7px] block h-[3px] w-8 shrink-0 rounded-sm shadow-[0_1px_3px_rgba(0,0,0,0.8)]"
            style={{ backgroundColor: color }}
        />
        <span className="legend-label">{label}</span>
    </div>
);

const ConvergenceZoneLegend = ({ currentLabel, climatologyLabel, isLoading = false }) => {
    if (!currentLabel && !climatologyLabel && !isLoading) return null;
    return (
        <section className="map-legend w-72 p-3" aria-label="29 degree convergence zone legend">
            <h4 className="legend-title">Convergence zone · 29°C SST</h4>
            <div className="mt-2.5 flex flex-col gap-2">
                {climatologyLabel && <LegendRow color="#4ade80" label={climatologyLabel} />}
                {currentLabel && <LegendRow color="#f472b6" label={currentLabel} />}
                {isLoading && <p className="legend-meta">Loading selected contour…</p>}
            </div>
            <p className="legend-meta mt-2.5 border-t border-white/10 pt-2">
                Solid lines only; no temperature infill.
            </p>
        </section>
    );
};

export default ConvergenceZoneLegend;
